import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { ACTION_LIST } from "models/role/action";
import { SUBJECT_CUSTOMER_BANK_LIST } from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const Configuration = lazyRetry(
  () => import("../pages/Configuration"),
  "CustomerBanksConfiguration"
);

export const configurationRoute: Route = {
  title: COMMON_TRANSLATION_KEYS.customerBankList,
  path: PAGE_URLS.configuration,
  component: Configuration,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_CUSTOMER_BANK_LIST,
  },
};
